import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

/**
 * @deprecated To be replaced by archivedWorkItemsJwmRoute
 * Delete when cleaning up slv-3_migrate_archived_issues_routes
 * See: https://jbusiness.atlassian.net/browse/SLV-3
 */
export const archivedIssuesJwmRoute: InvariantJiraRoute = {
	name: 'archived-issues-directory',
	path: '/jira/core/projects/:projectKey/issues/archive',
	exact: true,
};
